import { render } from "./settlement.vue?vue&type=template&id=3528d7d5&scoped=true"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"

import "./settlement.vue?vue&type=style&index=0&id=3528d7d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3528d7d5"]])

export default __exports__